import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App'; // Adjust the path if necessary
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

// root.render(<App />);
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);


